import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { isAdmin, isBarber, isCustomer } from '../../utils/roleUtils';
import { Home, Calendar, Search, User, LayoutDashboard, MessageCircle } from 'lucide-react';

const MobileBottomNav: React.FC = () => {
  const { state } = useAuth();
  const location = useLocation();
  const isMobile = useIsMobile();

  // Don't show on desktop or when not authenticated
  if (!isMobile) {
    return null;
  }

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const navItems = [
    {
      path: '/',
      icon: Home,
      label: 'Home',
      show: true,
    },
    {
      path: '/barbershops',
      icon: Search,
      label: 'Search',
      show: isCustomer(state.user?.role),
    },
    {
      path: '/bookings',
      icon: Calendar,
      label: 'Bookings',
      show: isCustomer(state.user?.role),
    },
    {
      path: '/messages',
      icon: MessageCircle,
      label: 'Messages',
      show: isCustomer(state.user?.role) || isBarber(state.user?.role),
    },
    {
      path: isAdmin(state.user?.role) ? '/admin/dashboard' : '/dashboard',
      icon: LayoutDashboard,
      label: 'Dashboard',
      show: state.isAuthenticated,
    },
    {
      path: '/login',
      icon: User,
      label: 'Account',
      show: !state.isAuthenticated,
    },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg safe-area-bottom"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto px-2">
        {navItems
          .filter(item => item.show)
          .map(({ path, icon: Icon, label }) => {
            const active = isActive(path);
            return (
              <Link
                key={path}
                to={path}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-[60px] transition-colors ${
                  active
                    ? 'text-primary-600 dark:text-primary-400'
                    : 'text-gray-600 dark:text-gray-400'
                }`}
                aria-label={label}
              >
                <Icon
                  size={24}
                  className={`mb-1 transition-all ${
                    active ? 'scale-110' : 'scale-100'
                  }`}
                />
                <span className="text-xs font-medium">{label}</span>
              </Link>
            );
          })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
